var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('aside', {
    staticClass: "table-resize-reset sup-resize-stop resize-stop maintree",
    class: [_vm.right ? 'control-sidebar control-sidebar-dark wtree_right' : 'main-sidebar pull-left sidebar-primary wtree_left'],
    staticStyle: {
      "transition": "none",
      "height": "100%"
    },
    style: (_vm.widthChanger),
    attrs: {
      "id": _vm.right ? 'right-sidebar' : 'sidebar-left'
    }
  }, [_c('section', {
    staticClass: "sidebar",
    staticStyle: {
      "padding": "0px"
    },
    style: ('margin-left:' + (_vm.right ? '0px' : '50px') + ';')
  }, [_c('li', {
    staticClass: "header",
    style: ('z-index: 9999; list-style: none; color: #999; padding: 0px; margin-bottom: 2px; position: absolute;' + _vm.pos_string),
    attrs: {
      "id": "buttons.resize_wrapper"
    }
  }, [(!_vm.right) ? _c('dynButton', {
    attrs: {
      "configs": {
        ID: 'buttons.resize',
        visible: true
      },
      "btnClasses": "resize-start",
      "icon": _vm.$root.icons.h_resize,
      "styleObj": {
        'border-width': '2px',
        //'border-top-right-radius': '35%',
        //'border-bottom-right-radius': '35%',
        //'border-left-style': 'none', 'border-right-style': 'solid',
        'border-color': '#999',
        'position': 'fixed',
        'top': '57px',
        'width': '28px',
        'height': '30px',
        'padding': '1px',
        'float': 'right',
        'cursor': 'w-resize',
        'background-color': '#666',
        'color': 'white'
      }
    },
    on: {
      "invisible": function($event) {
        _vm.hide('buttons.resize_wrapper')
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.right) ? _c('div', {
    staticClass: "right-btn-wrapper",
    staticStyle: {
      "position": "fixed",
      "top": "50px"
    }
  }, [_c('dynButton', {
    attrs: {
      "configs": {
        ID: 'buttons.resize',
        visible: true
      },
      "btnClasses": "resize-start",
      "icon": _vm.$root.icons.h_resize,
      "styleObj": {
        'border-width': '2px',
        //'border-top-left-radius': '35%',
        //'border-bottom-left-radius': '35%',
        //'border-left-style': 'solid', 'border-right-style': 'none',
        'border-color': '#999',
        'position': 'absolute',
        'right': '0px',
        'width': '28px',
        'height': '30px',
        'padding': '1px',
        'float': 'right',
        'cursor': 'w-resize',
        'background-color': '#666',
        'color': 'white'
      }
    },
    on: {
      "invisible": function($event) {
        _vm.hide('buttons.resize_wrapper')
      }
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), (_vm.showSearchMenu) ? _c('search-menu', {
    key: "2",
    attrs: {
      "right": _vm.right
    }
  }) : _vm._e(), _vm._v(" "), _c('sidebar-menu', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showSidebarMenu),
      expression: "showSidebarMenu"
    }],
    key: "1",
    attrs: {
      "right": _vm.right
    }
  })], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-137accbd","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sidebar.vue
// module id = 1427
// module chunks = 1